





































































































































































































































































































































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import InputArea from '@/components/common/modules/InputArea.vue';
import SelectArea from '@/components/common/modules/SelectArea.vue';
import TextArea from '@/components/common/modules/TextArea.vue';
import DatePickerArea from '@/components/common/modules/DatePickerArea.vue';
import DatePickerRangeArea from '@/components/common/modules/DatePickerRangeArea.vue';
import MasterSelectComboBox from '@/components/common/modules/MasterSelectComboBox.vue';
import MasterSelectControl from '@/components/common/modules/MasterSelectControl.vue';
import MasterSelectSetControl from '@/components/common/modules/MasterSelectSetControl.vue';
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import PopTextArea from '@/components/common/modules/PopTextArea.vue';
import SelectComboBoxArea from '@/components/common/modules/SelectComboBoxArea.vue';
import InputCalculation from '@/components/common/modules/InputCalculation.vue';
import InputUnitPriceQuantityCalculation from '@/components/common/modules/InputUnitPriceQuantityCalculation.vue';
import MasterSelectButton from '@/components/common/modules/MasterSelectButton.vue';
import FileManager from '@/components/common/modules/FileManager.vue';
import { FileFormResponse } from '@/constants/form/types';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SingleText from '@/components/common/elements/SingleText.vue';

interface CreateComponentProps {
  [k: string]: any;
}
@Component({
  components: {
    InputArea,
    SelectArea,
    TextArea,
    DatePickerArea,
    DatePickerRangeArea,
    MasterSelectComboBox,
    MasterSelectControl,
    MasterSelectSetControl,
    MasterSelectMultiSetControl,
    PopTextArea,
    SelectComboBoxArea,
    InputCalculation,
    InputUnitPriceQuantityCalculation,
    MasterSelectButton,
    FileManager,
    InputNoVModel,
    SingleText
  }
})
export default class RegistInputForm extends Vue {
  @Prop({ default: () => [] })
  private fieldData!: Array<{ [k: string]: any }>;
  @Prop({ default: () => [] })
  private fieldCols!: Array<{ [k: string]: any }>;
  @Prop({ default: '' })
  private addClass?: string;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;
  @Prop({ default: '' })
  private sumBillingAmount?: string;
  @Prop({ default: '' })
  private billingBalance?: string;

  @Emit('catchInput')
  private catchInput(data: any) {
    return data;
  }

  @Emit('emitFileData')
  private emitFileData(data: FileFormResponse): FileFormResponse {
    return data;
  }

  @Emit('openFileManagerDialog')
  private openFileManagerDialog(isOpen: boolean): boolean {
    return isOpen;
  }

  private getIndex(targetDisplayId: string) {
    return this.fieldData.findIndex((v: any) => v.display_id === targetDisplayId);
  }
}
